/**
 *  @directive sgElementForm
 *
 *  @param element {Object} - the template or project element
 *  @param modules {Object[]} - the template or project modules
 *  @param [constructions] {Object[]} - available project constructions
 *  @param appSection {String} - enum: ['template', 'project']
 *  @param [elementCategory] {String} - enum: ['technical', 'textual', 'all'] TODO implement this
 *  @param projectLevel {Number} - enum: [1,        2,      4,          5,    0]
 *                                      project, building, basic area, area, null
 *  @param action {String} - enum: ['create', 'copy', 'edit']
 *  @param constants {Object} - resolved Constants
 *  @param editorOptions {Object} - options for tinyMce editor
 *  @param [hiddenFields] {String[]} - String is one of the keys from the default below
 *  default: {
 *    name: false,
 *    label: false,
 *    projectLevel: false,
 *    constructionId: false,
 *    moduleId: false,
 *    submoduleId: false,
 *    knowledgeLevel: false,
 *    requirementType: false,
 *    requirementStrictness: false,
 *    hasInputInstruction: false,
 *    inputType: false,
 *    unit: false,
 *    hasMultipleQualityLevels: false,
 *    logAndComments: false,
 *    comment: false,
 *    appliesToFases: true,
 *    pveTemplates: appSection === 'project'
 * }
 * @param [disabledFields] {String[]} - String is one of the keys from the default below
 * default: {
      name: false,
      label: false,
      projectLevel: !!projectLevel,
      moduleId: false,
      submoduleId: false,
      knowledgeLevel: false,
      requirementType: false,
      requirementStrictness: false,
      hasInputInstruction: false,
      inputInstruction: false,
      inputType: false,
      hasMultipleQualityLevels: false,
      value: false,
      unit: false,
      comment: false,
      appliesToFases: false,
    };
  * */

(function () {
  angular
    .module('specsguardApp')
    .directive('sgElementForm', sgElementForm);

  function sgElementForm () {
    return {
      restrict: 'E',
      templateUrl: 'app-legacy/components/sg-element-form/sg-element-form.tmpl.html',
      controller: 'SgElementFormCtrl as $SgElementFormCtrl',
      bindToController: true,
      scope: {
        element: '<',
        modules: '<',
        constructions: '<',
        appSection: '@',
        projectLevel: '<',
        action: '@',
        editorOptions: '<',
        hiddenFieldsOptional: '<?hiddenFields',
        disabledFieldsOptional: '<?disabledFields',
        elementCategory: '@?',
        constants: '<',
        page: '@?'
      }
    };
  }
})();
